var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0957 13.6666H1.76237C0.841895 13.6666 0.0957031 12.9204 0.0957031 11.9999V1.99992C0.0957031 1.07944 0.841895 0.333252 1.76237 0.333252H5.0957V1.99992H1.76237V11.9999H5.0957V13.6666Z",
    fill: "#FF705D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5353 11.4874L10.7188 10.3139L7.45282 7.0201L15.0719 7.02006C15.5321 7.02006 15.9052 6.64696 15.9052 6.18673C15.9052 5.72649 15.5321 5.3534 15.0719 5.3534L7.43676 5.35344L10.7538 2.06442L9.58031 0.88092L4.25455 6.16167L9.5353 11.4874Z",
    fill: "#FF705D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.5b2226ab4eeb0e84a024c383e8980730.svg";
export { ForwardRef as ReactComponent };